<script lang="ts" setup>
import {
  setup,
  Props,
} from '@/common/components/molecules/virtualScrollList/virtualScrollList.setup';

const props = defineProps<Props>();

const { listRef, visibleList, vScrollInfo, onScroll, initVScrollInfo, updateVirtualScroll } =
  setup(props);

defineExpose({
  initVScrollInfo,
  updateVirtualScroll,
});
</script>

<template>
  <ul
    ref="listRef"
    class="virtual-scroll-list"
    @scroll.stop="onScroll"
  >
    <li
      v-show="vScrollInfo.top > 0"
      class="virtual-scroll-list__spacer"
      :style="{ height: `${vScrollInfo.top}px` }"
    />
    <template
      v-for="(item, index) in visibleList ?? []"
      :key="props.keyField ? item[props.keyField] : `${item.id}${index}`"
    >
      <slot
        name="list-item"
        :data="item"
        :index="index"
      />
    </template>
    <li
      v-show="vScrollInfo.bottom > 0"
      class="virtual-scroll-list__spacer"
      :style="{ height: `${vScrollInfo.bottom}px` }"
    />
  </ul>
</template>

<style lang="scss" scoped>
.virtual-scroll-list {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  overflow-anchor: none;

  &__spacer {
    clear: both;
    opacity: 0;
  }
}
</style>
